$(document).on('mouseover', '.featured-post__link__image--play, .featured-preek__image', function() {
    var iframe = $('video', this);

    iframe.css('opacity', '1');
    if($('.featured-post__link__image--play video').length || $('.featured-preek__image video').length){
        iframe.get(0).play(); // start video
    }
});

$(document).on('mouseleave', '.featured-post__link__image--play, .featured-preek__image', function() {
    var iframe = $('video', this);
    
    //iframe.get(0).currentTime = 0; // start form beginning
    iframe.css('opacity', '0');
    if($('.featured-post__link__image--play video').length || $('.featured-preek__image video').length){
        iframe.get(0).pause(); // pause video
    }
});

$(window).bind("pageshow", function(event) {
    if (event.originalEvent.persisted) {
        $('.single-preek__iframe').attr("src", $('.single-preek__iframe').attr("src"));
    }
});
